import { render, staticRenderFns } from "./contentSlider.vue?vue&type=template&id=5a1fe57e&scoped=true&"
import script from "./contentSlider.vue?vue&type=script&lang=ts&"
export * from "./contentSlider.vue?vue&type=script&lang=ts&"
import style0 from "./contentSlider.vue?vue&type=style&index=0&id=5a1fe57e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1fe57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1fe57e')) {
      api.createRecord('5a1fe57e', component.options)
    } else {
      api.reload('5a1fe57e', component.options)
    }
    module.hot.accept("./contentSlider.vue?vue&type=template&id=5a1fe57e&scoped=true&", function () {
      api.rerender('5a1fe57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grid/contentSlider.vue"
export default component.exports